import React from "react";
const CustomerGroupPage = () => {
  return (
    <div className="box-segment">
      <div className="table-segment-wrapper">
        <table className="app-v2-table">
          <thead className="app-v2-table-thead">
            <tr className="app-v2-table-tr">
              <th className="app-v2-table-th" style={{ minWidth: "200px" }}>
                Tên nhóm khách hàng
              </th>
              <th
                className="app-v2-table-th"
                style={{
                  minWidth: "95px",
                  maxWidth: "100px",
                  textAlign: "center",
                }}
              >
                Tổng lượt đăng ký
              </th>
              <th
                className="app-v2-table-th"
                style={{ minWidth: "95px", maxWidth: "98px" }}
              >
                Thời gian cập nhật
              </th>
              <th className="app-v2-table-th" style={{ minWidth: "160px" }}>
                Tài khoản đồng bộ
              </th>
              <th className="app-v2-table-th" style={{ minWidth: "120px" }}>
                Đồng bộ lên Facebook
              </th>
              <th
                className="app-v2-table-th"
                style={{ minWidth: "90px", textAlign: "center" }}
              >
                Đồng bộ
              </th>
              <th
                className="app-v2-table-th"
                style={{ minWidth: "90px", textAlign: "center" }}
              >
                Hành động
              </th>
            </tr>
          </thead>
        </table>
      </div>
    </div>
  );
};
export default CustomerGroupPage;
